import React from 'react';

import styled from 'styled-components';
import FullLayout2 from '../asyncIntake/screens/components/FullLayout';
import { Button, Flex, Heading, Text } from 'rebass';
import { measureHeight } from 'react-div-100vh';
import { LogoSvg } from './components/Logo';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import withSession from '../../lib/withSession';
import { isMobile } from 'react-device-detect';
import theme from '../../styles/theme';
import { ThinkCare } from '../becomeMemberNew/sections/ThinkCare';
import { withRouter } from 'react-router';

const data = [
  {
    name: '',
    uv: 1200,
  },
  {
    name: '1 mo',
    uv: 1000,
  },
  {
    name: '6 mo',
    uv: 400,
  },
  {
    name: '12 mo',
    uv: 200,
  },
  {
    name: '',
    uv: 150,
  },
];

const Container = styled(Flex)`
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding-top: 40px;
`;
const ScheduleEligibleWeightLossPage = ({ session, history, location, analytics }) => {
  const vh100 = `${measureHeight()}px` || '100vh';

  const goToSchedule = () => {
    history.push(`/schedulewl${location.search.indexOf('?skp=true') > -1 ? '?skp=true' : ''}`);
  };
  
  return (
    <FullLayout2
      style={{
        zIndex: 11,
        overflowY: 'auto',
        maxHeight: '',
        paddingLeft: '12px',
        paddingRight: '12px',
      }}
      pb={5}
    >
      <Container
        style={{
          maxWidth: 'min(880px, 90vw)',
          // height: 'auto !important',
          minHeight: vh100,
          overflow: 'hidden',
          alignItems: 'center',
        }}
      >
        <LogoSvg />
        <Flex
          style={{
            borderRadius: '20px',
            background: '#CFFEE6',
            borderRadius: '20px',
            padding: '8px 16px',
            marginTop: '30px',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 43 43" fill="none">
            <path d="M37.6257 12.5419L16.1257 34.0419L6.27148 24.1877L8.79773 21.6615L16.1257 28.9715L35.0994 10.0156L37.6257 12.5419Z" fill="#4E658A" />
          </svg>
          <Text style={{ fontSize: '17px', fontWeight: 600, color: '#4E658A' }}>You’re eligible to this program</Text>
        </Flex>
        <Heading style={{ textTransform: 'capitalize', textAlign: 'center', marginTop: '40px', maxWidth: 'min(660px, 80vw)', fontSize: '40px' }}>
          {session.firstName}, we can help you lose up to 20% of your body weight**
        </Heading>

        <Flex style={{ background: theme.color.darkBlue, borderRadius: 40, height: '360px', paddingBottom: '24px', maxWidth: '448px' }} mt={isMobile ? 3 : 4} flexDirection={'column'}>
          <Text style={{ color: 'white', fontSize: isMobile ? '20px' : '26px', fontWeight: 400, marginLeft: '20px', marginRight: '20px', marginBottom: '16px', marginTop: '24px' }}>
            Lose up to 20% of your weight
          </Text>
          <Text style={{ color: 'white', fontSize: '12px', marginBottom: '16px', marginLeft: '20px', marginRight: '20px' }}>
            On average, people lost 15–20% of their body weight in a 68-week clinical trial study of Wegovy®*
          </Text>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              width={500}
              height={400}
              data={data}
              margin={{
                top: 10,
                right: -80,
                left: -80,
                bottom: 0,
              }}
            >
              <defs>
                <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="15%" stopColor="white" stopOpacity={0.6} />
                  <stop offset="95%" stopColor="white" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="name" stroke="#a8a29b" />
              <Tooltip />
              <Area type="monotone" dataKey="uv" stroke="#fac66f" fill="url(#colorUv)" dot={{ stroke: '#fac66f', strokeWidth: 2, fill: '#fac66f', width: 8, height: 8 }} strokeWidth={4} />
            </AreaChart>
          </ResponsiveContainer>
        </Flex>

        <Button variant={'primary'} mt={4} onClick={goToSchedule}>
          Schedule your visit
        </Button>

        <Flex mt={5}>
          <ThinkCare hideTitle />
        </Flex>

        <Button variant={'primary'} mt={4} onClick={goToSchedule}>
          Schedule your visit
        </Button>

        <Text style={{ color: 'rgba(0, 0, 0, 0.33)', fontSize: '12px' }} mb={4} mt={5}>
          ** Graph for illustrative purposes only to demonstrate potential appetite suppression trends. Individual results will vary. *Along with a reduced calorie diet and increased exercise. In a
          68-week clinical study of Wegovy®, about 1 in 3 adults with obesity or with overweight and weight-related medical problems achieved 20% weight loss. Average weight loss achieved was 15%.
          Wegovy®is a registered trademark of Novo Nordisk A/S.
        </Text>
      </Container>
    </FullLayout2>
  );
};

export default withSession(withRouter(ScheduleEligibleWeightLossPage));
